<template>
  <v-navigation-drawer
    v-model="leftDrawer"
    app
    clipped
    fixed
    class="text--primary"
  >
    <v-list class="ma-2">
      <v-list-tile class="title">
        <v-icon class="text--primary mr-4 pr-2">
          account_circle
        </v-icon>
        <h3>{{ getUserName }}</h3>
      </v-list-tile>
      <v-divider class="primary" />
      <v-list-tile
        v-for="item in items"
        :key="item.title"
        :to="item.path"
      >
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>

        <v-list-tile-content>
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="logoutUser">
        <v-list-tile-action>
          <v-icon>meeting_room</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Salir</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TheSidebar',
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters(['user']),
    getUserName () {
      return this.user ? this.user.name : null
    },
    leftDrawer: {
      get () {
        return this.$store.getters.leftDrawer
      },
      set (newValue) {
        newValue || this.$store.dispatch('openDrawer', { open: false })
      }
    }
  },
  methods: {
    async logoutUser () {
      await this.$store.dispatch('logoutUser')
      window.sessionStorage.clear()
      await this.$router.replace({ name: 'LoginView' })
    }
  }
}
</script>

<style scoped>

</style>
